module.exports = __webpack_public_path__ + "img/antes_despues_70.8f6fed0c.png";